import keyBy from 'lodash/keyBy';
import isEmpty from 'lodash/isEmpty';
import { fetchFeatureFlags, toggleFeatureFlag } from './feature-flags.utils';

const featureFlags = {
    namespaced: true,
    state: {
        map: {},
    },
    mutations: {
        setMap (state, flags) {
            state.map = keyBy(flags, 'flagName');
        },
        setMapAtKey (state, flag) {
            state.map[flag.flagName] = flag;
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            const flags = await fetchFeatureFlags();
            commit('setMap', flags);
        },
        async toggle ({ commit }, { flagName, enabled }) {
            const flag = await toggleFeatureFlag(flagName, enabled);

            commit('setMapAtKey', flag);
        },
    },
    getters: {
        list: (state) => Object.values(state.map),
    },
};

export default featureFlags;